
// The builder's next-steps card (#721 spec §8.3, A.8; round-2 spec §13.2).
// Structure from enrollBlocks(): one block per option (a single option has no
// title), each with its steps: stay/bullets as a list, the move-to-supp
// sequence as a numbered list, carrier components in place of the generic
// lead, the Medicare.gov block(s) after the list; then the shared closing.
import card from '~/mixins/card'
import * as aep from '~/util/aep-recommendation'

export default {
    mixins: [card],
    props: {
        magicUrl: { type: String, default: '/' },
    },
    computed: {
        blocks () {
            return aep.enrollBlocks(this.aepContext)
        },
    },
    methods: {
        storePlan (enginePlan) {
            return enginePlan ? this.summaryPlansMap[enginePlan.id] || null : null
        },
    },
}
